module.exports = __webpack_public_path__ + "img/img-chapter-sm.3cde80dd.jpg";